export const types = {
  SET_LINK_LANDING_PREMADE_COLORS: "SET_LINK_LANDING_PREMADE_COLORS",
  SET_MUSIC_LINK_PREMADE_COLORS: "SET_MUSIC_LINK_PREMADE_COLORS",
};

export const setLinkLandingPremadeColors = payload => ({
  type: types.SET_LINK_LANDING_PREMADE_COLORS,
  payload,
});

export const setMusicLinkPremadeColors = payload => ({
  type: types.SET_MUSIC_LINK_PREMADE_COLORS,
  payload,
});
